(() => {
  if (customElements.get('launch-phone')) return;
  class LaunchPhone extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('select');
      this.display = this.querySelector('[data-country-display]');
      if (!this.select || !this.display) return;
      this.change = () => {
        const option = this.select.selectedOptions[0];
        if (!option) return;
        this.display.textContent = `${option.dataset.flag} ${option.dataset.dial} ▾`;
        this.display.hidden = false;
        this.classList.add('is-enhanced');
      };
      this.select.addEventListener('change', this.change);
      this.change();
    }
    disconnectedCallback() { if (this.select) this.select.removeEventListener('change', this.change); }
  }
  customElements.define('launch-phone', LaunchPhone);
})();
